export const countries = [
  { value: "852", label: "+852", maxLength: 8 },
  { value: "853", label: "+853", maxLength: 8 },
  { value: "86", label: "+86", maxLength: 11 },
];

export const locations = [
  { value: "", label: "Please select location<br/>請選擇地點" },
  {
    value: "CT",
    label:
      "Shop G3-G4, G/F, China Building, 29 Queens Road, Central<br/>中環皇后大道中29號華人行地下G3至G4號舖",
    shopTC: "三星專門店(中環)",
    shopEN: "Samsung Experience Store (Central)",
    operationTimeTC: "營業時間: 10:00 - 20:00",
    operationTimeEN: "Operation hours: 10:00 - 20:00",
    previewOperationTimeTC: "10:00 - 20:00",
    previewOperationTimeEN: "10:00 - 20:00",
    confirmedShopTC: "(中環) - 中環皇后大道中29號華人行地下G3至G4號舖",
    confirmedShopEN:
      "(Central) - Shop G3-G4, G/F, China Building, 29 Queens Road, Central",
  },
  {
    value: "OC",
    label:
      "Shop 332, Ocean Centre, Tsim Sha Tsui <br/> 尖沙咀海港城海洋中心3樓332號舖",
    shopTC: "三星專門店(尖沙咀)",
    shopEN: "Samsung Experience Store (Tsim Sha Tsui)",
    operationTimeTC: "營業時間: 11:00 - 21:30",
    operationTimeEN: "Operation hours: 11:00 - 21:30",
    previewOperationTimeTC: "11:00 - 21:30",
    previewOperationTimeEN: "11:00 - 21:30",
    confirmedShopTC: "(尖沙咀) - 尖沙咀海港城海洋中心3樓332號舖",
    confirmedShopEN: "(Tsim Sha Tsui) - Shop 332, Ocean Centre, Tsim Sha Tsui",
  },
  {
    value: "ST",
    label: "Shop 602, 6/F, New Town Plaza, Shatin<br/>沙田新城市廣場6樓602號舖",
    shopTC: "三星專門店(沙田)",
    shopEN: "Samsung Experience Store (Shatin)",
    operationTimeTC: "營業時間: 11:30 - 21:00",
    operationTimeEN: "Operation hours: 11:30 - 21:00",
    previewOperationTimeTC: "11:30 - 21:00",
    previewOperationTimeEN: "11:30 - 21:00",
    confirmedShopTC: "(沙田) - 沙田新城市廣場6樓602號舖",
    confirmedShopEN: "(Shatin) - Shop 602, 6/F, New Town Plaza, Shatin",
  },
  {
    value: "TF",
    label:
      "Shop G56-57, Telford Plaza I, 33 Wai Yip Street, Kowloon Bay<br/>九龍灣偉業街33號德福廣場一期地下G56-57號舖",
    shopTC: "三星專門店(九龍灣)",
    shopEN: "Samsung Experience Store (Kowloon Bay)",
    operationTimeTC: "營業時間: 11:00 - 21:00",
    operationTimeEN: "Operation hours: 11:00 - 21:00",
    previewOperationTimeTC: "11:00 - 21:00",
    previewOperationTimeEN: "11:00 - 21:00",
    confirmedShopTC: "(九龍灣) - 九龍灣偉業街33號德福廣場一期地下G56-57號舖",
    confirmedShopEN:
      "(Kowloon Bay) - Shop G56-57, Telford Plaza I, 33 Wai Yip Street, Kowloon Bay",
  },
  {
    value: "PC",
    label:
      "Shop G38-39, PopCorn 1, 9 Tong Yin Street, Tseung Kwan O<br/>將軍澳唐賢街9號PopCorn地下38-39號舖",
    shopTC: "三星專門店(將軍澳)",
    shopEN: "Samsung Experience Store (Tseung Kwan O)",
    operationTimeTC: "營業時間: 11:00 - 21:00",
    operationTimeEN: "Operation hours: 11:00 - 21:00",
    previewOperationTimeTC: "11:00 - 21:00",
    previewOperationTimeEN: "11:00 - 21:00",
    confirmedShopTC: "(將軍澳) - 將軍澳唐賢街9號PopCorn地下38-39號舖",
    confirmedShopEN:
      "(Tseung Kwan O) - Shop G38-39, PopCorn 1, 9 Tong Yin Street, Tseung Kwan O",
  },
  {
    value: "TW",
    label:
      "G001B, G/F, KOLOUR, Tsuen Wan I, 68 Chung On Street, Tsuen Wan<br/>荃灣眾安街68號荃灣千色匯 I 地下G001B號舖",
    shopTC: "三星專門店(荃灣)",
    shopEN: "Samsung Experience Store (Tsuen Wan)",
    operationTimeTC: "營業時間: 11:00 - 21:00",
    operationTimeEN: "Operation hours: 11:00 - 21:00",
    previewOperationTimeTC: "11:00 - 21:00",
    previewOperationTimeEN: "11:00 - 21:00",
    confirmedShopTC: "(荃灣) - 荃灣眾安街68號荃灣千色匯 I 地下G001B號舖",
    confirmedShopEN:
      "(Tsuen Wan) - G001B, G/F, KOLOUR, Tsuen Wan I, 68 Chung On Street, Tsuen Wan",
  },
  {
    value: "LY",
    label:
      "Shop 2006-2007, Level 2, YOHO Mall I, 9 Long Yat Road, Yuen Long, N.T.<br/>新界元朗朗日路 9號形點 I L2 2006-2007",
    shopTC: "三星專門店(元朗)",
    shopEN: "Samsung Experience Store (Yuen Long)",
    operationTimeTC: "營業時間: 11:00 - 21:30",
    operationTimeEN: "Operation hours: 11:00 - 21:30",
    previewOperationTimeTC: "11:00 - 21:30",
    previewOperationTimeEN: "11:00 - 21:30",
    confirmedShopTC: "(元朗) - 新界元朗朗日路 9號形點 I L2 2006-2007",
    confirmedShopEN:
      "(Yuen Long) - Shop 2006-2007, Level 2, YOHO Mall I, 9 Long Yat Road, Yuen Long, N.T.",
  },
  {
    value: "MK",
    label:
      "Shop No. M55, MTR Floor, MOKO, 193 Prince Edward Road West, Mongkok, Kowloon, H.K.<br/>旺角太子道西193號 MOKO新世紀廣場港鐵層 M55號舖",
    shopTC: "三星專門店(旺角)",
    shopEN: "Samsung Experience Store (Mong Kok)",
    operationTimeTC: "營業時間: 11:00 – 21:00",
    operationTimeEN: "Operation hours: 11:00 - 21:00",
    previewOperationTimeTC: "11:00 - 21:00",
    previewOperationTimeEN: "11:00 - 21:00",
    confirmedShopTC: "(旺角) - 旺角太子道西193號 MOKO新世紀廣場 港鐵層 M55號舖",
    confirmedShopEN:
      "(Mong Kok) - Shop No. M55, MTR Floor, MOKO, 193 Prince Edward Road West, Mongkok, Kowloon, H.K.",
  },
  {
    value: "KT",
    label:
      "Shop No. L216 & 217, 2nd Floor, AIRSIDE, 2 Concorde Road, Kai Tak<br/>啟德協調道2號 AIRSIDE 2樓 L216 & 217",
    shopTC: "三星專門店(啟德)",
    shopEN: "Samsung Experience Store (Airside)",
    operationTimeTC: "營業時間: 11:00 – 21:00",
    operationTimeEN: "Operation hours: 11:00 - 21:00",
    previewOperationTimeTC: "11:00 - 21:00",
    previewOperationTimeEN: "11:00 - 21:00",
    confirmedShopTC: "(啟德) - 啟德協調道2號 AIRSIDE 2樓 L216 & 217",
    confirmedShopEN:
      "(Airside) - Shop No. L216 & 217, 2nd Floor, AIRSIDE, 2 Concorde Road, Kai Tak",
  },
  {
    value: "TK",
    label:
      "Shop 219, 2/F, Cityplaza, 18 Taikoo Shing Road, Taikoo Shing<br/>太古太古城道18號太古城中心2樓219號舖",
    shopTC: "三星專門店(太古城)",
    shopEN: "Samsung Experience Store (Taikoo Shing)",
    operationTimeTC: "營業時間: 11:00 – 21:00",
    operationTimeEN: "Operation hours: 11:00 - 21:00",
    previewOperationTimeTC: "11:00 - 21:00",
    previewOperationTimeEN: "11:00 - 21:00",
    confirmedShopTC: "(太古城) - 太古太古城道18號太古城中心2樓219號舖",
    confirmedShopEN:
      "(Taikoo Shing) - Shop 219, 2/F, Cityplaza, 18 Taikoo Shing Road",
  },
  {
    value: "OS",
    label: "Samsung Online Shop or Samsung Shop App<br/> Samsung 網上商店或Samsung Shop App",
    shopTC: "Samsung 網上商店或Samsung Shop App",
    shopEN: "Samsung Online Shop or Samsung Shop App",
    operationTimeTC: "",
    operationTimeEN: "",
    previewOperationTimeTC: "N/A",
    previewOperationTimeEN: "",
    confirmedShopTC: "Samsung 網上商店或Samsung Shop App",
    confirmedShopEN: "Samsung Online Shop or Samsung Shop App",
  },
];
